import { useState } from 'react'

import PropTypes from 'prop-types'
import {
  Box,
  Button,
  FormControlLabel,
  Grid,
  Switch,
  TextField,
} from '@material-ui/core'
import { Controller, useFormContext } from 'react-hook-form'
import { Repeat as RepeatIcon } from 'react-feather'

import {
  Card,
  LabelIconStart,
  MenuButton,
  UserTypeAndSearchInput,
} from 'components'

const ResponsibleDpoForm = ({
  disableCertFields,
  setChangeResponsibleDialog = () => {},
}) => {
  const [selectExistentResponsible, setSelectExistentResponsible] = useState('')

  const { errors, control, register } = useFormContext()

  const handleChangeResponsibleSelection = () =>
    setSelectExistentResponsible(!selectExistentResponsible)

  return (
    <Card
      title="Preencha as informações do responsável do Grupo Advisor"
      menuButton
      actionButton={
        disableCertFields && (
          <Box display="flex" alignItems="center">
            <MenuButton>
              <Button
                key="Alterar Responsável"
                color="secondary"
                fullWidth
                onClick={() => setChangeResponsibleDialog(true)}
              >
                <LabelIconStart
                  icon={<RepeatIcon size={20} />}
                  label="Alterar Responsável"
                />
              </Button>
            </MenuButton>
          </Box>
        )
      }
    >
      {!disableCertFields && (
        <Grid item xs={12}>
          <FormControlLabel
            control={
              <Switch
                checked={!!selectExistentResponsible}
                color="primary"
                onChange={handleChangeResponsibleSelection}
              />
            }
            inputRef={register}
            name="selectExistentResponsible"
            labelPlacement="start"
            label="Criar Grupo Advisor com usuário existente"
          />
        </Grid>
      )}
      {selectExistentResponsible ? (
        <Grid item xs={12}>
          <UserTypeAndSearchInput
            label="Email do Responsável"
            fieldName="responsibleDpo"
            searchField="email"
          />
        </Grid>
      ) : (
        <Grid container spacing={1} justifyContent="flex-start">
          <Grid item xs={12} md={disableCertFields ? 12 : 6}>
            <Controller
              as={
                <TextField
                  fullWidth
                  error={!!errors.responsibleName}
                  helperText={errors?.responsibleName?.message}
                  label="Nome do responsável"
                  disabled={disableCertFields}
                />
              }
              control={control}
              name="responsibleName"
              mode="onBlur"
            />
          </Grid>
          {!disableCertFields && (
            <Grid item xs={12} md={6}>
              <Controller
                as={
                  <TextField
                    fullWidth
                    error={!!errors.responsibleEmail}
                    helperText={errors?.responsibleEmail?.message}
                    label="E-mail do responsável"
                  />
                }
                control={control}
                name="responsibleEmail"
                mode="onBlur"
              />
            </Grid>
          )}
        </Grid>
      )}
    </Card>
  )
}

ResponsibleDpoForm.propTypes = {
  disableCertFields: PropTypes.bool,
  setChangeResponsibleDialog: PropTypes.func,
}

export default ResponsibleDpoForm
